import './App.css';
import AboutSection from './components/AboutPage';
import Contact from './components/Contacts';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import Location from './components/Location';
import NavBar from './components/NavBar';

function App() {
  return (
    <div className="App">
      <NavBar />
      <HomePage />
      <AboutSection />
      <Contact />
      <Location />
      <Footer />
    </div>
  );
}

export default App;
